import { connect } from 'react-redux';
import { showReportModal } from '../../../../Moderation/redux/actions';
import { showMobileDeviationSharePopup, pushNftLinkPopup, } from '../../../../Modals/redux/actionCreators';
import { getIsCurrentUserAuthorOf } from '../../../../redux/deviations/selectors';
import { shareDeviationToPost } from '../../../../redux/deviations/actionCreators';
var mapStateToProps = function (state, ownProps) { return ({
    isOwner: getIsCurrentUserAuthorOf(state, ownProps.deviation),
}); };
var mapDispatchToProps = {
    showReportModal: showReportModal,
    showMobileDeviationSharePopup: showMobileDeviationSharePopup,
    shareDeviationToPost: shareDeviationToPost,
    showNftLinkPopup: pushNftLinkPopup,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=MoreMenuMobileDropdown.container.js.map